import { AlertTriangle } from 'lucide-react';
import Modal from '../Modal';
import { Analysis } from '../../types';

interface DeleteConfirmModalProps {
  analysis: Analysis | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function DeleteConfirmModal({
  analysis,
  isDeleting,
  onConfirm,
  onClose
}: DeleteConfirmModalProps) {
  if (!analysis) return null;

  return (
    <Modal
      isOpen={!!analysis}
      onClose={onClose}
      title="Confirmar Exclusão"
    >
      <div className="space-y-4">
        <div className="flex items-center space-x-3 p-4 bg-error-500/10 border border-error-500/30 rounded-lg">
          <AlertTriangle className="h-6 w-6 text-error-500 flex-shrink-0" />
          <p className="text-error-600 dark:text-error-400 font-medium">
            Tem certeza que deseja excluir esta análise?
          </p>
        </div>

        <p className="text-sm text-navy-500 dark:text-navy-400">
          Esta ação não poderá ser desfeita e todos os dados relacionados serão perdidos.
        </p>

        <div className="flex justify-end space-x-3 pt-4 border-t border-navy-200 dark:border-navy-700">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 text-navy-600 dark:text-navy-300 hover:bg-navy-100 dark:hover:bg-navy-800 rounded-lg transition-colors duration-200"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 bg-error-500 text-white rounded-lg hover:bg-error-600 disabled:bg-error-400 transition-colors duration-200"
          >
            {isDeleting ? 'Excluindo...' : 'Excluir'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
